import type {PermissionsRecordType} from '../permissions';

export const workshopPermissions = {
  createCatalogueItem: {
    resourceId: 'LABOUR_CATALOGUE_ITEM',
    actionId: 'CREATE',
    scopes: [],
  },
  editCatalogueItem: {
    resourceId: 'LABOUR_CATALOGUE_ITEM',
    actionId: 'EDIT',
    scopes: [],
  },
  readCatalogueItem: {
    resourceId: 'LABOUR_CATALOGUE_ITEM',
    actionId: 'READ',
    scopes: [],
  },
  deleteCatalogueItem: {
    resourceId: 'LABOUR_CATALOGUE_ITEM',
    actionId: 'DELETE',
    scopes: [],
  },
  moveCatalogueItemToFolder: {
    resourceId: 'LABOUR_CATALOGUE_ITEM',
    actionId: 'MOVE_TO_FOLDER',
    scopes: [],
  },
  createLabourCatalogue: {
    resourceId: 'LABOUR_CATALOGUE',
    actionId: 'CREATE',
    scopes: [],
  },
  deleteLabourCatalogue: {
    resourceId: 'LABOUR_CATALOGUE',
    actionId: 'DELETE',
    scopes: [],
  },
  editLabourCatalogue: {
    resourceId: 'LABOUR_CATALOGUE',
    actionId: 'EDIT',
    scopes: [],
  },
  readLabourCatalogue: {
    resourceId: 'LABOUR_CATALOGUE',
    actionId: 'READ',
    scopes: [],
  },
  materialDispatch: {
    resourceId: 'SERVICE_ITEM',
    actionId: 'MATERIAL_DISPATCH',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE'],
  },
  materialNonBinding: {
    resourceId: 'SERVICE_ITEM',
    actionId: 'MATERIAL_NON_BINDING',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE'],
  },
  materialRequest: {
    resourceId: 'SERVICE_ITEM',
    actionId: 'MATERIAL_REQUEST',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE'],
  },
  allowBankTransfer: {
    resourceId: 'CUSTOMER',
    actionId: 'ALLOW_BANK_TRANSFER',
    scopes: [],
  },
  createCustomerOrder: {
    resourceId: 'CUSTOMER',
    actionId: 'CREATE_CUSTOMER_ORDER',
    scopes: [],
  },
} satisfies PermissionsRecordType;
